import StartAdvancingSessionModal from "./StartAdvancingSessionModal";
import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCustomQuery } from "utilities/hookutils";
import QueryPagination from "pagination/components/querypagination";
import Panel from "components/panels/panel";
import AdvancingRowCard from "advancingapprove/list/AdvancingRowCard";
import { useShortcutPanel } from "components/Shortcuts/hooks";
import { ButtonSecondary } from "components/Atoms/Button";
interface Props {
  showId: number
  config: server.dto.AdvancingInShowPanelConfig
}

const AdvancingSessionsPanel = (props: Props) => {
  const [isStarting, setIsStarting] = React.useState(false);
  const [templates, setTemplates] = React.useState<server.dto.AdvancingTemplate[]>(undefined);

  const queryClient = useQueryClient();

  const templatesQuery = useCustomQuery({
    queryKey: ["advancingTemplatesForNewSession"],
    queryFn: () => window.CoreApi.AdvancingTemplate.Paginated({ page: 1, perPage: 100 }).then(r => r.data.data),
    enabled: isStarting,
    cacheTime: 0,
    onSuccess: setTemplates
  });

  const onInviteClicked = () => {
    setIsStarting(true);
  };

  const onClose = () => {
    setIsStarting(false);
    setTemplates(undefined);
  };

  const onSessionCreated = () => {
    onClose();
    queryClient.invalidateQueries({ queryKey: ["advancingList"] });
  };

  const maxPerPage = 10;

  const [instruction, setInstruction] = React.useState<server.dto.PaginatedAdvancingSessionInstruction>({
    page: 1,
    perPage: maxPerPage,
    showIds: [props.showId]
  });

  const advancingQuery = useCustomQuery({
    queryKey: ["advancingList", instruction],
    queryFn: async () => window.CoreApi.AdvancingSession.Paginated(instruction).then(r => r.data),
    cacheTime: 0,
    keepPreviousData: true
  });

  const { refToScrollTo } = useShortcutPanel({
    type: "advancing",
    label: props.config.headerLabel,
    totalItems: advancingQuery.data?.data?.length || 0,
    onAddClicked: props.config.canAdd ? onInviteClicked : undefined
  });

  return <>
    {templates && <StartAdvancingSessionModal
      showId={props.showId}
      templates={templates}
      onSessionCreated={onSessionCreated}
      onClose={onClose}
    />}
    <Panel
      panelClassName="s1_related-feature-panel"
      panelRef={refToScrollTo}
      title={props.config.headerLabel}
      pagination={<QueryPagination
        page={instruction.page}
        onPageChanged={page => { setInstruction(prev => ({ ...prev, page })); }}
        query={advancingQuery}
      />}
      hasData={advancingQuery.data?.data.length > 0}
      isLoading={advancingQuery.data == null}
      hasError={advancingQuery.isError}
      articleId={serverReference.supportArticleIds.whatIsAdvancing}
      button={props.config.canAdd && <ButtonSecondary onClick={onInviteClicked} loading={templatesQuery.isFetching} label={RESX.Advancing.InviteSomeone} />}
    >
      <div className="advancing-session-list">
        {advancingQuery.data?.data.map(row => (
          <AdvancingRowCard key={row.advancingSession.advancingSessionId} item={row} />
        ))}
      </div>
    </Panel>
  </>;
};

export default AdvancingSessionsPanel;
